import { Dialog as MuiDialog, DialogTitle, IconButton, DialogContent, styled } from "@mui/material";
import { memo } from "react";
import CrossIcon from "../../../assets/images/icons/cross.icon";

const Dialog = styled(MuiDialog)({
	'& .MuiPaper-root': {
		overflowY: 'inherit',
		borderRadius: 10,
		border: 0
	}
});

const BsModal = memo(({ title, open, size = 'xs', onClose, children, fullWidth = false, PaperProps = {} }) => (
	<Dialog
		fullWidth={fullWidth}
		open={open}
		onClose={onClose}
		maxWidth={size}
		PaperProps={PaperProps}
	>
		{title && <DialogTitle className="m-0 p-3 border-b border-[#DDDDDD] text-center">{title}</DialogTitle>}
		<IconButton
			aria-label="close"
			onClick={onClose}
			className="absolute top-[-30px] right-[-34px] text-neutral-100 rounded-circle"
		>
			<CrossIcon color="#ffffff" size={16} />
		</IconButton>
		<DialogContent dividers className="border-bottom-0 border-0">
			{children}
		</DialogContent>
	</Dialog>
));

export default BsModal;
